import React from "react";
import ReactiveComponent from "@usereactify/search-internals/lib/components/basic/ReactiveComponent";

import { useReactifySearchContext } from "../../hooks";
import { getPropsSensorCollection } from "../../utility/props";

export const SensorCollection: React.FC = () => {
  const reactifySearchContext = useReactifySearchContext();
  const reactiveProps = getPropsSensorCollection({
    config: reactifySearchContext.config,
    provider: reactifySearchContext.options,
  });

  if (!reactiveProps) {
    return null;
  }

  return (
    <ReactiveComponent
      {...reactiveProps}
    />
  );
};
